import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { IconTile } from '../ui';
import { QUICK_ACCESS } from '../../data/home';

export default function QuickAccess() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const openLanguage = () => navigate({ pathname: location.pathname, search: location.search, hash: 'language' });

  return (
    <section className="quick-wrap" aria-label={t('Quick access')}>
      <div className="container">
        <div className="quick card">
          {QUICK_ACCESS.map((q) => (
            <IconTile
              key={q.label}
              icon={q.icon}
              label={t(q.label)}
              sub={t(q.sub)}
              to={q.action ? undefined : q.to}
              onClick={q.action === 'language' ? openLanguage : undefined}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
